module.exports = __webpack_public_path__ + "static/media/Account.7cae85d9.svg";